import { ChangeDetectorRef, Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { Validateable } from "@models/interfaces";
import { ValidationError } from "@models";
import { PasswordAuth } from "@models/password_auth";
import { Helper } from "@helpers/functions";
import { AuthService } from "bp-authorization-lib";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { InfoService } from "@core-services/info.service";

@Component({
	selector: "password-validation",
	templateUrl: "./password-validation-modal.component.html",
	styleUrls: ["./password-validation-modal.component.scss"],
	standalone: false
})
export class PasswordValidationModalComponent {
	@Input() public headerButtonKey: string = "cancel";
	@Input() public headerTitleKey: string = "password_validation_title";
	@Input() public descriptionKey: string = "password_validation_description";

	public passwordInput: string;
	public passwordError: Validateable;

	@Output() public onPasswordValidated: EventEmitter<PasswordAuth> = new EventEmitter();
	@Output() public onClickBack: EventEmitter<void> = new EventEmitter();

	private readonly cdr = inject(ChangeDetectorRef);

	public constructor(
		private apiCallService: ApicallService,
		private infoService: InfoService,
		private authService: AuthService
	) {}

	public onClickHeaderButton(): void {
		this.onClickBack.emit();
	}

	public onClickConfirm(): void {
		if (!this.passwordInput) {
			return;
		}
		this.cdr.markForCheck();

		let argumentsObj = { password: this.passwordInput };
		let options = new ApicallOption(PasswordAuth, argumentsObj);

		this.apiCallService.put("user/password-auth", options).subscribe(
			(res) => {
				this.passwordInput = "";
				argumentsObj = options = null;

				this.onPasswordValidated.emit(res[0]);
			},
			(error) => {
				if (error instanceof ValidationError) {
					if (error.metaContains("password")) {
						this.passwordError = new Validateable();
						this.passwordError.setValidationErrors(error);
					} else {
						this.infoService.setError(error);
					}
				} else {
					Helper.handleError(error);
				}
			}
		);
	}

	public get forgotPasswordLink(): string {
		return this.authService.getApiUrl() + this.authService.getEnv()["authorization"]["mapOAuth"]["lostPassword"];
	}
}
